import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import ClipboardEvidenceModal from "./ClipboardEvidenceModal";

const EvidenceModalContext = createContext(null);

export const EvidenceModalProvider = ({ children }) => {
  const [detail, setDetail] = useState(null);

  const open = useCallback((nextDetail) => {
    if (!nextDetail) return;
    setDetail(nextDetail);
  }, []);

  const close = useCallback(() => setDetail(null), []);

  useEffect(() => {
    if (!detail) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        close();
      }
    };
    document.body.classList.add("modal-open");
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.classList.remove("modal-open");
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [close, detail]);

  const value = useMemo(() => ({ open, close, detail }), [close, detail, open]);

  return (
    <EvidenceModalContext.Provider value={value}>
      {children}
      <ClipboardEvidenceModal detail={detail} onClose={close} />
    </EvidenceModalContext.Provider>
  );
};

export const useEvidenceModal = () => {
  const ctx = useContext(EvidenceModalContext);
  if (!ctx) {
    throw new Error("useEvidenceModal must be used inside EvidenceModalProvider");
  }
  return ctx;
};

export default EvidenceModalProvider;
